import React from 'react';
import './Marquee.css';

const items = ['Laravel', 'Node.js', 'Angular', 'React', 'Vue', 'Flutter', 'Ionic', 'WordPress'];
const line = [...items, ...items].join(' ✕ ') + ' ✕';

// Two identical halves so the -50% translate loops seamlessly.
const Marquee = () => (
  <div className="marquee" aria-hidden="true">
    <div className="marquee-track">
      <span>{line}</span>
      <span>{line}</span>
    </div>
  </div>
);

export default Marquee;
